/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import { DataRProdutoFiscal } from "../../../shared/services/api/Fiscal/ServiceRelatorioFinanceiro";

// Paisagem — são 19 colunas (descrição + EAN + código interno + un +
// estoque + todos os campos fiscais), não cabe em A4 retrato como o
// relatório de NF-e (ver Rnfepdf.ts, 8 colunas).
async function RelatorioFiscalProdutos(dados: DataRProdutoFiscal[]) {

  const linhas: any[] = [];

  dados.forEach((p) => {
    linhas.push([
      { text: p.descricao ?? "", fontSize: 6.5 },
      { text: p.ean ?? "", fontSize: 6.5 },
      { text: p.codinterno ?? "", fontSize: 6.5 },
      { text: p.un ?? "", fontSize: 6.5, alignment: "center" },
      { text: formatNumero(p.quan), fontSize: 6.5, alignment: "right" },
      { text: p.ncm ?? "", fontSize: 6.5 },
      { text: p.cest ?? "", fontSize: 6.5 },
      { text: p.cfop ?? "", fontSize: 6.5, alignment: "center" },
      { text: p.origem ?? "", fontSize: 6.5, alignment: "center" },
      { text: p.cst ?? "", fontSize: 6.5, alignment: "center" },
      { text: p.cstipi ?? "", fontSize: 6.5, alignment: "center" },
      { text: p.cstcofins ?? "", fontSize: 6.5, alignment: "center" },
      { text: p.cstpis ?? "", fontSize: 6.5, alignment: "center" },
      { text: formatPercent(p.icms), fontSize: 6.5, alignment: "right" },
      { text: formatPercent(p.ppis), fontSize: 6.5, alignment: "right" },
      { text: formatPercent(p.pcofins), fontSize: 6.5, alignment: "right" },
      { text: formatPercent(p.pipi), fontSize: 6.5, alignment: "right" },
      { text: p.cprodanp ?? "", fontSize: 6.5 },
      { text: p.descanp ?? "", fontSize: 6.5 },
    ]);
  });

  const cabecalho = [
    "Descrição", "EAN", "Cód. Interno", "Un", "Estoque",
    "NCM", "CEST", "CFOP", "Origem", "CST", "CST IPI", "CST COFINS", "CST PIS",
    "ICMS %", "PIS %", "COFINS %", "IPI %", "Cód. ANP", "Desc. ANP",
  ].map((texto) => ({ text: texto, bold: true, fillColor: "#e5e7eb", fontSize: 6.5 }));

  const documentDefinition: any = {
    pageSize: "A4",
    pageOrientation: "landscape",
    pageMargins: [18, 20, 18, 20],

    content: [
      {
        text: process.env.REACT_APP_URL_EMPRESA,
        fontSize: 13,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 4],
      },
      {
        text: "RELATÓRIO FISCAL DE PRODUTOS EM ESTOQUE",
        fontSize: 11,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 2],
      },
      {
        text: `${dados.length} produto(s) com estoque maior que zero`,
        alignment: "center",
        fontSize: 8,
        margin: [0, 0, 0, 8],
      },
      {
        table: {
          headerRows: 1,
          widths: [
            "*", 55, 45, 22, 35,
            40, 35, 30, 30, 25, 30, 40, 32,
            28, 28, 32, 28, 35, "*",
          ],
          body: [cabecalho, ...linhas],
        },
        layout: {
          fillColor: (rowIndex: number) => (rowIndex === 0 ? null : rowIndex % 2 === 0 ? "#f9fafb" : null),
          hLineColor: () => "#d1d5db",
          vLineWidth: () => 0,
        },
      },
    ],
  };

  pdfMake.createPdf(documentDefinition).open();
}

function formatNumero(value: number) {
  return new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(Number(value ?? 0));
}

function formatPercent(value: number | null) {
  if (value === null || value === undefined) return "";
  return new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
}

export default RelatorioFiscalProdutos;
